import { useIntl } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import type { Currency } from '../../../../prop-types/currency-types';
import { DeclaredValueInput } from './declared-value-input';

import messages from '../messages';
import { CustomsField } from '../customs-field';

type CustomsDeclaredValueProps = {
  declaredAmount?: Currency;
  onChange: (value: number, code: string) => void;
};

export const CustomsDeclaredValue = ({ declaredAmount, onChange }: CustomsDeclaredValueProps) => {
  const intl = useIntl();
  const defaultAmount: Currency = { value: 0, code: '' };

  return (
    <CustomsField label={messages.itemValueLabel} required>
      <DeclaredValueInput
        aria-label={intl.formatMessage(messages.itemValueLabel)}
        declaredAmount={declaredAmount ?? defaultAmount}
        onChange={onChange}
      />
      <Text textType={TextType.Caption} value={messages.itemValueHelperText} />
    </CustomsField>
  );
};
